import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./drop-down.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./drop-down.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedConstants } from '../../constants/shared.constants';
import { SearchTableService } from '../../services/table-column-mapping/search-table.service';
import { AutoUnsub } from '../../decorators/autounsub.decorator';
let DropDownComponent = class DropDownComponent {
    searchTableService;
    changeDetectorRef;
    options = [];
    valueSelected = new EventEmitter();
    stateReset = new EventEmitter();
    preSelected;
    placeholder = SharedConstants.PLACEHOLDER_TEXT;
    doNotSort = false;
    recheckOptions = false;
    selectedTab;
    selected = '';
    propertySearchOptionsAsObservableSubscription;
    preSelectedSearchOptionAsObservableSubscription;
    constructor(searchTableService, changeDetectorRef) {
        this.searchTableService = searchTableService;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        if (this.preSelected && this.options && !this.options.includes(this.preSelected)) {
            throw new Error(`Pre-selected value ${this.preSelected} is not present in the options`);
        }
        this.refreshSelectionOptions();
        if (this.recheckOptions) {
            this.listenForOptionChanges();
            this.listenForPreSelectionChanges();
        }
    }
    ngOnChanges(changes) {
        if (changes['selectedTab']) {
            this.resetSelection();
        }
    }
    refreshSelectionOptions() {
        if (!this.placeholder) {
            this.placeholder = SharedConstants.PLACEHOLDER_TEXT;
        }
        if (this.preSelected) {
            this.selected = this.preSelected;
            this.valueSelected.emit(this.selected);
        }
        if (!this.doNotSort && this.options)
            this.options.sort();
    }
    // the property / cemeteries location search requires a more dynamic setting for the options in the drop-down
    listenForOptionChanges() {
        this.propertySearchOptionsAsObservableSubscription = this.searchTableService.propertySearchOptionsAsObservable.subscribe((searchOptions) => {
            this.options = [...searchOptions];
            this.changeDetectorRef.detectChanges();
        });
    }
    listenForPreSelectionChanges() {
        this.preSelectedSearchOptionAsObservableSubscription = this.searchTableService.preSelectedSearchOptionAsObservable.subscribe((preSelect) => {
            if (preSelect && preSelect !== "" && this.options) {
                if (!this.preSelected) {
                    this.preSelected = preSelect;
                    this.refreshSelectionOptions();
                }
            }
        });
    }
    resetSelection() {
        this.selected = this.placeholder;
        this.stateReset.emit(true);
        this.refreshSelectionOptions();
        this.changeDetectorRef.detectChanges(); // Ensure changes are detected
    }
    emitValueChange($event) {
        const value = $event.target.value;
        if (value === this.placeholder) {
            this.stateReset.emit(true);
            return;
        }
        this.valueSelected.emit(value);
    }
    static ctorParameters = () => [
        { type: SearchTableService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        options: [{ type: Input }],
        valueSelected: [{ type: Output }],
        stateReset: [{ type: Output }],
        preSelected: [{ type: Input }],
        placeholder: [{ type: Input }],
        doNotSort: [{ type: Input }],
        recheckOptions: [{ type: Input }],
        selectedTab: [{ type: Input }]
    };
};
DropDownComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-drop-down[options]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], DropDownComponent);
export { DropDownComponent };
